import { safeDeleteSheet } from "@/lib/office-helpers";

const VEHICLES_ROWS: (string | number)[][] = [
  ["HFX063", "", "Automóvil", "Sedan", 2009, "Rojo", 11000],
  ["HFX064", "", "Automóvil", "Sedan", 2015, "Negro", 26750],
  ["HFX065", "", "Automóvil", "Camioneta", 2016, "Negro", 32890],
  ["HFX066", "", "Bote", "Jet Ski", 2014, "Negro/Amarillo", 4550],
  ["HFX067", "", "Bote", "Jet Ski", 2014, "Negro/Amarillo", 4550],
  ["HFX068", "", "Bote", "Barco de velocidad", 1999, "Blanco", 7000],
  ["HFX069", "", "Bote", "Bote de pesca", 1994, "Blanco", 3500],
  ["HFX070", "", "Bote", "Bote de pesca", 1986, "Beige", 3700],
  ["HFX071", "", "Bote", "Casa flotante", 2001, "Blanco/Naranja", 14000],
  ["HFX072", "", "Vehículo recreacional", "ATV", 2006, "Rojo", 1600],
  ["HFX073", "", "Vehículo recreacional", "ATV", 2006, "Azul", 1600],
  ["HFX074", "", "Vehículo recreacional", "ATV", 2010, "Negro", 1600],
  ["HFX075", "", "Vehículo recreacional", "ATV", 2004, "Negro", 1600],
  ["HFX076", "", "Vehículo recreacional", "Vehículo recreacional", 2008, "Café claro", 29780],
];

const SOLD_ROWS: (string | number)[][] = [
  ["Aparato", "Licuadora", "HFX001", 4, 36.69, 146.76],
  ["Aparato", "Cafetera", "HFX008", 2, 39.3, 78.6],
  ["Aparato", "Cafetera (prensa francesa)", "HFX010", 3, 31.13, 93.39],
  ["Aparato", "Parrilla (eléctrica)", "HFX004", 1, 19.41, 19.41],
  ["Aparato", "Parrilla (gas)", "HFX006", 4, 13.28, 53.12],
  ["Aparato", "Secador de pelo", "HFX007", 10, 17.02, 170.2],
  ["Aparato", "Microondas", "HFX012", 9, 51.47, 463.23],
  ["Aparato", "Refrigerador", "HFX014", 7, 29.7, 207.9],
  ["Aparato", "Tostadora", "HFX003", 5, 23.02, 115.1],
  ["Electrónica", "Computadora de escritorio", "HFX018", 4, 39.36, 157.44],
  ["Electrónica", "Computadora (laptop)", "HFX015", 3, 18.43, 55.29],
  ["Electrónica", "Reproductor de mp3", "HFX022", 5, 35.72, 178.6],
  ["Electrónica", "Consola de videojuegos", "HFX020", 5, 29.7, 148.5],
  ["Mueble", "Puf", "HFX037", 2, 11.19, 22.38],
  ["Mueble", "Cama (completa)", "HFX045", 7, 12.29, 86.03],
  ["Mueble", "Cama (King)", "HFX049", 7, 45.72, 320.04],
  ["Mueble", "Cama (Queen)", "HFX046", 3, 10.88, 32.64],
  ["Mueble", "Cama (Twin)", "HFX042", 4, 47.1, 188.4],
  ["Mueble", "Banco", "HFX036", 5, 21.75, 108.75],
  ["Mueble", "Silla (reclinable)", "HFX033", 7, 24.04, 168.28],
  ["Mueble", "Sillas (x4)", "HFX030", 3, 10, 30],
  ["Mueble", "Sofá", "HFX025", 1, 15.52, 15.52],
  ["Mueble", "Centro de entretenimiento", "HFX040", 4, 47.93, 191.72],
  ["Mueble", "Conjunto de patio", "HFX034", 9, 21.33, 191.97],
  ["Mueble", "Mesa", "HFX028", 5, 4.7, 23.5],
  ["Recreacional", "Red de bádminton", "HFX059", 8, 3.11, 24.88],
  ["Recreacional", "Bate de béisbol", "HFX056", 7, 6.62, 46.34],
  ["Recreacional", "Aro de baloncesto", "HFX054", 1, 48.74, 48.74],
  ["Recreacional", "Bicicleta", "HFX060", 1, 46.52, 46.52],
  ["Recreacional", "Porteria", "HFX058", 5, 17.23, 86.15],
  ["Recreacional", "Pelota deportiva", "HFX051", 5, 42.15, 210.75],
  ["Vehículo", "Automóvil", "HFX073", 1, 11000, 11000],
  ["Vehículo", "Automóvil", "HFX074", 1, 26750, 26750],
  ["Vehículo", "Automóvil", "HFX075", 1, 32890, 32890],
  ["Vehículo", "Bote", "HFX070", 1, 3500, 3500],
  ["Vehículo", "Bote", "HFX071", 1, 3700, 3700],
  ["Vehículo", "Bote", "HFX072", 1, 14000, 14000],
  ["Vehículo", "Bote", "HFX063", 1, 4550, 4550],
  ["Vehículo", "Bote", "HFX064", 1, 4550, 4550],
  ["Vehículo", "Bote", "HFX069", 1, 7000, 7000],
  ["Vehículo", "Vehículo reacreacional", "HFX065", 1, 1600, 1600],
  ["Vehículo", "Vehículo reacreacional", "HFX066", 1, 1600, 1600],
  ["Vehículo", "Vehículo reacreacional", "HFX067", 1, 1600, 1600],
  ["Vehículo", "Vehículo reacreacional", "HFX068", 1, 1600, 1600],
  ["Vehículo", "Vehículo reacreacional", "HFX076", 1, 29780, 29780],
];

export async function startProject21(): Promise<void> {
  await Excel.run(async (context) => {
    await safeDeleteSheet(context, "Vehículos");
    await safeDeleteSheet(context, "VehÃ­culos");
    await safeDeleteSheet(context, "Vendido");

    const vehicles = context.workbook.worksheets.add("Vehículos");
    const sold = context.workbook.worksheets.add("Vendido");

    vehicles.getRange("A1:G1").merge();
    vehicles.getRange("A1").values = [["Venta de Excedentes del Gobierno"]];
    vehicles.getRange("A1").format.font.size = 28;
    vehicles.getRange("A1").format.font.color = "#70AD47";
    const vehicleTable = vehicles.tables.add("A3:G3", true);
    vehicleTable.name = "VehiculosExcedentes";
    vehicleTable.getHeaderRowRange().values = [[
      "Lote#",
      "Código",
      "Tipo",
      "Estilo",
      "Año",
      "Color",
      "Precio",
    ]];
    vehicleTable.rows.add(undefined, VEHICLES_ROWS);
    vehicleTable.style = "TableStyleMedium7";
    vehicles.getRange("G4:G17").numberFormat = Array(VEHICLES_ROWS.length).fill(["0"]);

    sold.getRange("A1:F1").merge();
    sold.getRange("A1").values = [["Venta de excedentes del gobierno"]];
    sold.getRange("A1").format.font.size = 28;
    sold.getRange("A1").format.font.color = "#70AD47";
    const soldTable = sold.tables.add("A3:F3", true);
    soldTable.name = "VendidoQ1";
    soldTable.getHeaderRowRange().values = [[
      "Tipo de artículo",
      "Descripción",
      "Lote #",
      "Cantidad",
      "Precio",
      "Total",
    ]];
    soldTable.rows.add(undefined, SOLD_ROWS);
    soldTable.style = "TableStyleMedium7";
    soldTable.showBandedRows = false;
    sold.getRange("E4:F48").numberFormat = Array(SOLD_ROWS.length).fill([
      "0.00",
      "0.00",
    ]);
    sold.getRange("A49:B49").merge();
    sold.getRange("A49").values = [["Total de ventas Q1"]];
    sold.getRange("C49").values = [[104444.73]];

    vehicles.activate();
    vehicles.getRange("A1").select();
    await context.sync();
  });
}
